// WDCE-199 step 9g-4a: FoodTableOrderTable.jsx's delivery-fee auto-sync condition, moved here so it can be tested with
// bin/js-test. When delivery isn't required but a fee is still shown, the table PATCHes the fee away with no click
// (WDCE-311/312/316). Today's condition exactly, quirks included (only "0" and "0.00" count as zero, and the number 0
// becomes ""), plus the EFTPOS lock: nothing is sent while the checkout is locked (9g-4).

// The digits and dots of a fee as shown ("$15.00" -> "15.00").
export const parseFee = (feeString) => (feeString || '').toString().replace(/[^0-9.]/g, '')

export function shouldClearDeliveryFee({ editable, locked, deliveryRequired, deliveryFee }) {
  if (!editable || locked) return false
  if (deliveryRequired !== false) return false

  return parseFee(deliveryFee) !== '0' && parseFee(deliveryFee) !== '0.00'
}
